// extracted by mini-css-extract-plugin
export default {"ruleContainer":"AlertRule_ruleContainer__oS-+N","cross":"AlertRule_cross__6jxmw"};